// Centralized API URL configuration for GCP deployment
// Empty string means relative paths (works with proxy in dev, LB in production)
// Set REACT_APP_API_URL for cross-origin setups (e.g., https://elm.dveracity.com)
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';
